import {
  setWindowPosition, stopWindow, setAllWindows,
  setCurtainPosition, stopCurtain,
  setLight, setFan, setAcEnabled, setPump,
  reasonMessage,
} from '../mockStore.js';
import { t } from '../i18n.js';

export function renderActuators(root, state, { canControl }) {
  const lang = state.lang;
  const typhoon = state.mode === 'typhoon' || state.hardwareLocks.typhoonFieldLock;
  const lowWater = state.water.tankLevelPct < state.water.lowLevelThreshold;
  const acOn = state.ac.enabled;

  root.innerHTML = `
    <div class="view">
      <h2 class="view-title">${t(lang, 'actuators')}</h2>
      ${typhoon ? `<div class="lock-reason">颱風鎖：窗／簾遠端開被禁止；風扇補光肥水冷氣已停。</div>` : ''}

      <div class="grid grid-2" style="margin-top:10px">
        <div class="card controls-only">
          <h3>自動窗（4×24V 推桿）</h3>
          <div class="btn-row">
            <button type="button" class="btn sm" data-all-win="0" ${typhoon ? 'disabled' : ''}>全部關</button>
            <button type="button" class="btn sm" data-all-win="50" ${typhoon ? 'disabled' : ''}>全部 50%</button>
            <button type="button" class="btn sm" data-all-win="100" ${typhoon ? 'disabled' : ''}>全部開</button>
          </div>
          ${state.windows.map((w) => `
            <div class="toggle-row" style="flex-wrap:wrap">
              <div>
                <span class="label">${w.name}</span>
                <span class="hint">${w.moving ? '移動中' : '靜止'} · ${w.atLimitClose ? '限位關' : ''} ${w.atLimitOpen ? '限位開' : ''} ${w.fault ? '故障:' + w.fault : ''}</span>
              </div>
              <div class="slider-row" style="width:100%">
                <input type="range" min="0" max="100" value="${w.position}" data-win="${w.id}" ${typhoon || w.fault ? 'disabled' : ''} />
                <span class="pct">${w.position}%</span>
                <button type="button" class="btn sm" data-stop-win="${w.id}">Stop</button>
              </div>
            </div>`).join('')}
        </div>

        <div class="card controls-only">
          <h3>屋頂簾（1×24V）</h3>
          <div class="slider-row">
            <input type="range" min="0" max="100" value="${state.curtain.position}" data-curtain ${typhoon || state.curtain.fault ? 'disabled' : ''} />
            <span class="pct">${state.curtain.position}%</span>
            <button type="button" class="btn sm" data-stop-curtain>Stop</button>
          </div>
          <div class="meta">0 = 收回 · 100 = 全遮；中途可 Stop</div>

          <h3 style="margin-top:14px">燈光（分路）</h3>
          <div class="toggle-row">
            <div><span class="label">白光行人燈</span><span class="hint">circuit: white-walkway</span></div>
            <button type="button" class="btn sm ${state.lights.whiteWalkway.on ? 'primary' : ''}" data-light="white" ${typhoon ? 'disabled' : ''}>
              ${state.lights.whiteWalkway.on ? 'ON' : 'OFF'}
            </button>
          </div>
          <div class="toggle-row">
            <div><span class="label">紅光補光（三層）</span><span class="hint">circuit: red-grow — 同白光分開</span></div>
            <button type="button" class="btn sm ${state.lights.redGrow.on ? 'accent' : ''}" data-light="red" ${typhoon ? 'disabled' : ''}>
              ${state.lights.redGrow.on ? 'ON' : 'OFF'}
            </button>
          </div>

          <h3 style="margin-top:14px">扇／冷氣</h3>
          <div class="toggle-row">
            <div><span class="label">排風／抽氣</span><span class="hint">${acOn ? '冷氣 ON → 強制 OFF' : ''}</span></div>
            <button type="button" class="btn sm ${state.fans.exhaust.on ? 'primary' : ''}" data-fan="exhaust" ${typhoon || acOn ? 'disabled' : ''}>
              ${state.fans.exhaust.on ? 'ON' : 'OFF'}
            </button>
          </div>
          <div class="toggle-row">
            <div><span class="label">循環扇</span></div>
            <button type="button" class="btn sm ${state.fans.circulate.on ? 'primary' : ''}" data-fan="circulate" ${typhoon ? 'disabled' : ''}>
              ${state.fans.circulate.on ? 'ON' : 'OFF'}
            </button>
          </div>
          <div class="toggle-row">
            <div><span class="label">冷氣使能</span><span class="hint">開啟會強制關排風</span></div>
            <button type="button" class="btn sm ${state.ac.enabled ? 'primary' : ''}" data-ac ${typhoon ? 'disabled' : ''}>
              ${state.ac.enabled ? 'ENABLED' : 'OFF'}
            </button>
          </div>

          <h3 style="margin-top:14px">泵／閥</h3>
          ${lowWater ? `<div class="lock-reason">低水位：灌溉泵／肥泵已禁</div>` : ''}
          <div class="toggle-row">
            <div><span class="label">灌溉泵</span></div>
            <button type="button" class="btn sm ${state.water.irrigationPump.on ? 'primary' : ''}" data-pump="irrigation" ${typhoon || lowWater ? 'disabled' : ''}>
              ${state.water.irrigationPump.on ? 'ON' : 'OFF'}
            </button>
          </div>
          <div class="toggle-row">
            <div><span class="label">街水閥</span></div>
            <button type="button" class="btn sm ${state.water.streetValve.on ? 'primary' : ''}" data-pump="street" ${typhoon ? 'disabled' : ''}>
              ${state.water.streetValve.on ? 'ON' : 'OFF'}
            </button>
          </div>
          <div class="toggle-row">
            <div><span class="label">肥泵</span></div>
            <button type="button" class="btn sm ${state.water.fertPump.on ? 'primary' : ''}" data-pump="fert" ${typhoon || lowWater ? 'disabled' : ''}>
              ${state.water.fertPump.on ? 'ON' : 'OFF'}
            </button>
          </div>
        </div>
      </div>

      <div class="card" style="margin-top:10px">
        <h3>覆寫紀錄（人手保持會寫入）</h3>
        <div class="log-box">
          ${state.overrideLog.slice(0, 20).map((l) =>
            `<div>${l.ts.slice(11, 19)} [${l.role}/${l.mode}] ${l.action} ${JSON.stringify(l.detail)}</div>`
          ).join('') || '<div>（尚未有覆寫）</div>'}
        </div>
      </div>
      <div id="act-toast" class="lock-reason" style="display:none;margin-top:10px"></div>
    </div>
  `;

  const toast = root.querySelector('#act-toast');
  function show(r) {
    if (!r) return;
    if (r.ok) { toast.style.display = 'none'; return; }
    toast.style.display = 'block';
    toast.textContent = reasonMessage(r.reason, lang);
  }

  root.querySelectorAll('[data-win]').forEach((el) => {
    el.addEventListener('change', () => show(setWindowPosition(el.dataset.win, el.value)));
  });
  root.querySelectorAll('[data-stop-win]').forEach((el) => {
    el.addEventListener('click', () => show(stopWindow(el.dataset.stopWin)));
  });
  root.querySelectorAll('[data-all-win]').forEach((el) => {
    el.addEventListener('click', () => show(setAllWindows(el.dataset.allWin)));
  });
  const curt = root.querySelector('[data-curtain]');
  if (curt) curt.addEventListener('change', () => show(setCurtainPosition(curt.value)));
  const stopC = root.querySelector('[data-stop-curtain]');
  if (stopC) stopC.addEventListener('click', () => show(stopCurtain()));

  root.querySelectorAll('[data-light]').forEach((el) => {
    el.addEventListener('click', () => {
      const circuit = el.dataset.light;
      const cur = circuit === 'white' ? state.lights.whiteWalkway.on : state.lights.redGrow.on;
      show(setLight(circuit, !cur));
    });
  });
  root.querySelectorAll('[data-fan]').forEach((el) => {
    el.addEventListener('click', () => {
      const which = el.dataset.fan;
      const cur = which === 'exhaust' ? state.fans.exhaust.on : state.fans.circulate.on;
      show(setFan(which, !cur));
    });
  });
  const ac = root.querySelector('[data-ac]');
  if (ac) ac.addEventListener('click', () => show(setAcEnabled(!state.ac.enabled)));
  root.querySelectorAll('[data-pump]').forEach((el) => {
    el.addEventListener('click', () => {
      const which = el.dataset.pump;
      const map = { irrigation: state.water.irrigationPump.on, fert: state.water.fertPump.on, street: state.water.streetValve.on };
      show(setPump(which, !map[which]));
    });
  });
}
